'use client'

import { FC } from 'react'

import cn from 'clsx'

import usePopularSearches from '@hooks/usePopularSearches'

import PopularJobItem from './popular-job-item'

import styles from './popular-jobs.module.scss'

import { PopularJobsProps } from '.'

const ClintSidePopularJobs: FC<PopularJobsProps> = ({
  numberOfResults = 4,
  type,
  className = '',
  removeLocations = false,
}) => {
  const { data } = usePopularSearches(numberOfResults)

  const classes = cn(styles[type], className)
  return (
    <div className={`${styles['popular-jobs']}`}>
      <div className={classes} data-cy="popular-jobs">
        {Array.isArray(data) &&
          data?.map((item, i) => <PopularJobItem key={i} data={item} removeLocation={removeLocations} type={type} />)}
      </div>
    </div>
  )
}

export default ClintSidePopularJobs
